// extracted by mini-css-extract-plugin
export default {"loadContainer":"LoadIndicator_loadContainer__FFsJ9","spinner":"LoadIndicator_spinner__2Bcot"};